<template>
  <div class="relative">
    <div class="top-0 right-4 flex justify-between">
      <h2>Edit Service Provider Details</h2>
      <feather-icon icon="XIcon" @click="handleClose" />
    </div>

    <div class="w-full pt-5">
      <p class="fsize15">First Name</p>
      <base-input
        v-model="firstname"
        placeholder="Enter firstname"
        name="First Name"
        class="cust-form-border"
      ></base-input>
    </div>

    <div class="w-full pt-5">
      <p class="fsize15">Last Name</p>
      <base-input
        v-model="lastname"
        placeholder="Enter lastname"
        name="Last Name"
        class="cust-form-border"
      ></base-input>
    </div>

    <div class="w-full pt-3">
      <p class="fsize15">Email</p>
      <base-input
        v-model="email"
        placeholder="Enter email"
        name="email"
        class="cust-form-border"
        disabled
      ></base-input>
    </div>

    <div class="w-full pt-3">
      <p class="fsize15">Contact No</p>
      <base-input
        v-model="mobile"
        placeholder="Enter number"
        :rules="{ numeric: true, required: true, regex: '^[0-9]{10}$' }"
        name="contact number"
        class="cust-form-border"
        disabled
      ></base-input>
    </div>
    <!-- <div class="w-full pt-3">
      <p class="fsize15">Date of Birth </p>
      <base-input
        type="date"
        value="DOB"
        name="DOB"
        class="form-control-muted mb-4"
        placeholder="Enter Date of birth"
        v-model="dob"
        :max="maxDate"
      />
    </div> -->
    <div class="w-full pt-3">
      <p class="fsize15">Gender</p>
      <el-select
        placeholder="gender"
        v-model="gender"
        class="w-full custselect"
      >
        <el-option label="Male" value="Male"></el-option>
        <el-option label="Female" value="Female"></el-option>
        <el-option label="Transgender" value="Transgender"></el-option>
        <el-option
          label="Prefer not to say"
          value="Prefer not to say"
        ></el-option>
      </el-select>
    </div>

    <div class="w-full pt-3">
      <p class="fsize15">Location</p>
      <!-- <b-form-select
        v-model="location"
        :options="platformOptions"
        class="mb-3"
        value-field="item"
        text-field="name"
      >
      </b-form-select> -->
      <base-input
        v-model="location"
        placeholder="Enter location"
        name="location"
        class="cust-form-border"
      ></base-input>
    </div>
    <div class="w-full pt-3">
      <p class="fsize15">Description</p>
      <base-input
        v-model="aboutServicePro"
        placeholder="Description"
        name="email"
        class="cust-form-border"
      ></base-input>
    </div>
    <div class="w-full pt-3">
      <p class="fsize15">Service Type</p>
      <b-form-select
        v-model="serviceType"
        :options="serviceTypeOptions"
        class="mb-3"
        value-field="item"
        text-field="name"
      >
      </b-form-select>
    </div>
    <div class="w-full pt-3">
      <p class="fsize15">Services</p>
      <b-form-select
        v-model="service"
        :options="services"
        class="mb-3"
        value-field="item"
        text-field="name"
      >
      </b-form-select>
    </div>

    <div class="w-full pt-3">
      <p class="fsize15">Designation</p>
      <base-input
        v-model="designation"
        placeholder="Enter designation"
        name="designation"
        class="cust-form-border"
      ></base-input>
    </div>
    <div class="w-full pt-3">
      <p class="fsize15">
        Designation Headline (if filled designation field above)
      </p>
      <base-input
        v-model="designationheadline"
        placeholder="Enter designation headline"
        name="designationheadline"
        class="cust-form-border"
      ></base-input>
    </div>
    <!-- <div v-show="isServiceProvider"> -->
    <div class="w-full pt-3">
      <p class="fsize15">Price</p>
      <base-input
        v-model="price"
        placeholder="Enter price"
        name="price"
        :rules="{ numeric: true }"
        class="cust-form-border"
      ></base-input>
    </div>
    <div class="w-full pt-3">
      <p class="fsize15">Bank Name</p>
      <base-input
        v-model="bankName"
        placeholder="Enter bank Name"
        name="bank name"
        class="cust-form-border"
      ></base-input>
    </div>
    <div class="w-full pt-3">
      <p class="fsize15">Account Number</p>
      <base-input
        v-model="accountNumber"
        placeholder="Enter Account Number"
        name="Account Number"
        :rules="{ numeric: true, regex: '^[0-9]{9,18}$' }"
        class="cust-form-border"
      ></base-input>
    </div>
    <div class="w-full pt-3">
      <p class="fsize15">IFSC Code</p>
      <base-input
        v-model="IFSCCode"
        placeholder="Enter IFSC Code"
        name="IFSC Code"
        class="cust-form-border"
        :rules="{ regex: '^[A-Z]{4}0[A-Z0-9]{6}$' }"
      ></base-input>
    </div>
    <!-- </div> -->
    <div class="w-full pt-3">
      <p class="fsize15">Experience In Years</p>
      <base-input
        v-model="experience"
        placeholder="Enter experience in years"
        name="experience"
        class="cust-form-border"
      ></base-input>
    </div>
    <div class="w-full pt-3">
      <p class="fsize15">Expertise (Eg.Stroke Specialization)</p>
      <base-input
        v-model="expertise"
        placeholder="Enter your expertise"
        name="expertise"
        class="cust-form-border"
      ></base-input>
    </div>
    <div class="w-full pt-3">
      <p class="fsize15">Social Media (Eg. LinkedIn )</p>
      <base-input
        v-model="social"
        placeholder="Enter social media link"
        name="social media"
        class="cust-form-border"
      ></base-input>
    </div>
    <div class="w-full pt-3">
      <FileUploader :image="profImage" :onSuccess="handleSuccess" />
    </div>
    <div v-if="showPreviousImg">
      <img :src="`${$imageURL}/${profImage}`" alt="" />
    </div>
    <div v-else class="relative" v-show="image">
      <img :src="image" alt="profileImage" class="h-52 w-full object-cover" />
      <div class="absolute top-0 right-0 m-2">
        <div
          class="bg-white rounded-full p-1 cursor-pointer"
          @click="handleRemove"
        >
          <feather-icon
            icon="XIcon"
            class="flex text-primary"
            svgClasses="w-4 h-4"
          />
        </div>
      </div>
    </div>

    <div class="pt-5 flex justify-center">
      <button
        class="bg-primary text-white px-8 py-2 rounded"
        type="submit"
        @click="onSubmit()"
      >
        Submit
      </button>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import FileUploader from "@/components/FileUploader";
import { Cropper } from "vue-advanced-cropper";
export default {
  props: {
    selectedItemId: {
      type: Object,
    },
    // getVolunteerFunc: Function,
  },
  components: {
    FileUploader,
    Cropper,
  },
  data() {
    return {
      firstname: "",
      lastname: "",
      mobile: "",
      email: "",

      // dob: "",
      gender: "",
      location: "",
      platformOptions: [],
      aboutServicePro: "",
      serviceType: "",
      // serviceTypeOptions: ["Volunteer", "Service Provider"],
      serviceTypeOptions: ["Individual", "Institutional"],
      service: "",
      designation: "",
      designationheadline: "",
      services: [],

      price: "",
      bankName: "",
      accountNumber: "",
      IFSCCode: "",
      expertise: "",
      experience: "",
      social: "",

      maxDate: null,
      // isServiceProvider: false,
      profImage: "",
      image: "",
      showPreviousImg: false,
    };
  },
  computed: {
    ...mapState("respitecare", {
      get_all_location_name: "get_all_location_name",
    }),
    ...mapState("services", { get_AllService: "get_AllService" }),
  },
  watch: {
    // async selectedItemId(value) {
    //   if (value) {
    //     await this.getVolunteer();
    //   }
    // },
  },
  methods: {
    handleRemove() {
      this.image = null;
      this.profImage = null;
    },
    handleSuccess(image) {
      if (image.type.includes("image")) {
        let mByte = 5 * 1048576;
        if (image.size > mByte) {
          this.$swal.fire({
            title: "File size exceeds the allowed limit!",
            html: "<p style='text-align:center'>Please ensure that the file size does not exceed 5MB</p>",
            confirmButtonText: "Okay",
            icon: "warning",
            confirmButtonColor: "#830c81",
            showCancelButton: false,
          });
          return;
        }
        this.profImage = image;
        this.showPreviousImg = false;
        this.readerData(image);
      } else {
        this.$swal.fire({
          title: "Invalid File Type!",
          html: "<p style='text-align:center'>Please upload Image only</p>",
          confirmButtonText: "Okay",
          icon: "warning",
          confirmButtonColor: "#830c81",
          showCancelButton: false,
        });
        return;
      }
    },
    async readerData(rawFile) {
      const reader = new FileReader();
      reader.onload = (e) => {
        this.image = e.target.result;
      };
      await reader.readAsDataURL(rawFile);
    },
    handleClose() {
      this.$bvModal.hide("edit-volunteer");
    },
    async onSubmit() {
      // let payload = {
      //   userId: this.selectedItemId.userId[0]._id,
      //   volunteerId: this.selectedItemId._id,
      // };

      // if (this.selectedItemId.userId[0].firstname != this.firstname) {
      //   Object.assign(payload, { firstname: this.firstname });
      // }
      // if (this.selectedItemId.userId[0].lastname != this.lastname) {
      //   Object.assign(payload, { lastname: this.lastname });
      // }
      // if (this.selectedItemId.userId[0].mobile != this.mobile) {
      //   Object.assign(payload, { mobile: this.mobile });
      // }

      // if (this.selectedItemId.gender != this.gender) {
      //   Object.assign(payload, { gender: this.gender });
      // }
      // // if (this.selectedItemId.DOB != this.dob) {
      // //   Object.assign(payload, { dob: this.dob });
      // // }
      // if (this.selectedItemId.location != this.location) {
      //   Object.assign(payload, { location: this.location });
      // }
      // if (this.selectedItemId.aboutServicePro != this.aboutServicePro) {
      //   Object.assign(payload, { aboutServicePro: this.aboutServicePro });
      // }
      // if (this.selectedItemId.serviceType != this.serviceType) {
      //   Object.assign(payload, { serviceType: this.serviceType });
      // }
      // if (this.selectedItemId.service != this.service) {
      //   Object.assign(payload, { service: this.service });
      // }
      // if (this.selectedItemId.price != this.price) {
      //   Object.assign(payload, { price: this.price });
      // }
      // if (this.selectedItemId.bankName != this.bankName) {
      //   Object.assign(payload, { bankName: this.bankName });
      // }
      // if (this.selectedItemId.accountNumber != this.accountNumber) {
      //   Object.assign(payload, { accountNumber: this.accountNumber });
      // }
      // if (this.selectedItemId.IFSCCode != this.IFSCCode) {
      //   Object.assign(payload, { IFSCCode: this.IFSCCode });
      // }
      // if (this.selectedItemId.socialMedia != this.social) {
      //   Object.assign(payload, { socialMedia: this.social });
      // }
      // if (this.selectedItemId.experience != this.experience) {
      //   Object.assign(payload, { experience: this.experience });
      // }
      // if (this.selectedItemId.expertise != this.expertise) {
      //   Object.assign(payload, { expertise: this.expertise });
      // }

      let formData = new FormData();

      formData.append("userId", this.selectedItemId.userId[0]._id);
      formData.append("volunteerId", this.selectedItemId._id);

      if (this.selectedItemId.userId[0].firstname !== this.firstname) {
        formData.append("firstname", this.firstname);
      }
      if (this.selectedItemId.userId[0].lastname !== this.lastname) {
        formData.append("lastname", this.lastname);
      }
      if (this.selectedItemId.userId[0].mobile !== this.mobile) {
        formData.append("mobile", this.mobile);
      }

      if (this.selectedItemId.gender !== this.gender) {
        formData.append("gender", this.gender);
      }
      if (this.selectedItemId.location !== this.location) {
        formData.append("location", this.location);
      }
      if (this.selectedItemId.aboutServicePro !== this.aboutServicePro) {
        formData.append("aboutServicePro", this.aboutServicePro);
      }
      if (this.selectedItemId.serviceType !== this.serviceType) {
        formData.append("serviceType", this.serviceType);
      }
      if (this.selectedItemId.service !== this.service) {
        formData.append("service", this.service);
      }
      if (this.selectedItemId.designation !== this.designation) {
        formData.append("designation", this.designation);
      }
      if (
        this.selectedItemId.designationheadline !== this.designationheadline
      ) {
        formData.append("designationheadline", this.designationheadline);
      }
      if (this.selectedItemId.price !== this.price) {
        formData.append("price", this.price);
      }
      if (this.selectedItemId.bankName !== this.bankName) {
        formData.append("bankName", this.bankName);
      }
      if (this.selectedItemId.accountNumber !== this.accountNumber) {
        formData.append("accountNumber", this.accountNumber);
      }
      if (this.selectedItemId.IFSCCode !== this.IFSCCode) {
        formData.append("IFSCCode", this.IFSCCode);
      }
      if (this.selectedItemId.socialMedia !== this.social) {
        formData.append("socialMedia", this.social);
      }
      if (this.selectedItemId.experience !== this.experience) {
        formData.append("experience", this.experience);
      }
      if (this.selectedItemId.expertise !== this.expertise) {
        formData.append("expertise", this.expertise);
      }
      if (!this.showPreviousImg && this.profImage) {
        formData.append("profile", this.profImage);
      }

      // Now you can use formData with fetch or any other API call

      let loader = this.$loading();

      try {
        let data = await this.$store.dispatch(
          "respitecare/editvolunteer",
          formData
        );

        loader.close();
        if (data.code == 200) {
          this.$bvModal.hide("edit-volunteer");
          await this.$swal.fire({
            text: "Volunteer updated successfully",
            icon: "success",
            confirmButtonText: "Okay",
            confirmButtonColor: "#830c81",
            showCancelButton: false,
          });
          this.getVolunteerFunc();
        }
      } catch (error) {
        loader.close();
        console.log(error);
        if (error.response.status == 400) {
          this.$router.push({ name: "signin" });
          this.$swal.fire({
            title: "Session Expired",
            text: "Your session has ended and for security reasons, we request you to login again",
            icon: "warning",
            confirmButtonColor: "#830c81",
            showCancelButton: false,
          });
          loader.close();
        } else if (error.response.status == 409) {
          loader.close();
          this.$swal.fire({
            text: error.response.data.message,
            icon: "error",
            confirmButtonColor: "#830c81",
            showCancelButton: false,
          });
          this.$router.push({ name: "login" });
        } else if (error) {
          console.log("something went wrong...", err);
          loader.close();
          this.$swal.fire({
            text: "Something went wrong",
            icon: "error",
            confirmButtonColor: "#830c81",
            showCancelButton: false,
          });
        }
      }
    },
    async getVolunteer() {
      this.firstname =
        this.selectedItemId.userId[0].hasOwnProperty("firstname") &&
        this.selectedItemId.userId[0].firstname
          ? this.selectedItemId.userId[0].firstname
          : "";
      this.lastname =
        this.selectedItemId.userId[0].hasOwnProperty("lastname") &&
        this.selectedItemId.userId[0].lastname
          ? this.selectedItemId.userId[0].lastname
          : "";
      this.mobile =
        this.selectedItemId.userId[0].hasOwnProperty("mobile") &&
        this.selectedItemId.userId[0].mobile
          ? this.selectedItemId.userId[0].mobile
          : "";
      this.email =
        this.selectedItemId.userId[0].hasOwnProperty("email") &&
        this.selectedItemId.userId[0].email
          ? this.selectedItemId.userId[0].email
          : "";

      this.gender =
        this.selectedItemId.hasOwnProperty("gender") &&
        this.selectedItemId.gender
          ? this.selectedItemId.gender
          : "";
      this.location =
        this.selectedItemId.hasOwnProperty("location") &&
        this.selectedItemId.location
          ? this.selectedItemId.location
          : "";
      this.aboutServicePro =
        this.selectedItemId.hasOwnProperty("aboutServicePro") &&
        this.selectedItemId.aboutServicePro
          ? this.selectedItemId.aboutServicePro
          : "";
      this.serviceType =
        this.selectedItemId.hasOwnProperty("serviceType") &&
        this.selectedItemId.serviceType
          ? this.selectedItemId.serviceType
          : "";
      this.service =
        this.selectedItemId.hasOwnProperty("service") &&
        this.selectedItemId.service
          ? this.selectedItemId.service
          : "";
      this.designation =
        this.selectedItemId.hasOwnProperty("designation") &&
        this.selectedItemId.designation
          ? this.selectedItemId.designation
          : "";
      this.designationheadline =
        this.selectedItemId.hasOwnProperty("designationheadline") &&
        this.selectedItemId.designationheadline
          ? this.selectedItemId.designationheadline
          : "";
      // this.DOB = this.selectedItemId.dob;

      this.price =
        this.selectedItemId.hasOwnProperty("price") && this.selectedItemId.price
          ? this.selectedItemId.price
          : "";
      this.bankName =
        this.selectedItemId.hasOwnProperty("bankName") &&
        this.selectedItemId.bankName
          ? this.selectedItemId.bankName
          : "";
      this.accountNumber =
        this.selectedItemId.hasOwnProperty("accountNumber") &&
        this.selectedItemId.accountNumber
          ? this.selectedItemId.accountNumber
          : "";
      this.IFSCCode =
        this.selectedItemId.hasOwnProperty("IFSCCode") &&
        this.selectedItemId.IFSCCode
          ? this.selectedItemId.IFSCCode
          : "";
      this.expertise =
        this.selectedItemId.hasOwnProperty("expertise") &&
        this.selectedItemId.expertise
          ? this.selectedItemId.expertise
          : "";
      this.experience =
        this.selectedItemId.hasOwnProperty("experience") &&
        this.selectedItemId.experience
          ? this.selectedItemId.experience
          : "";
      this.socialMedia =
        this.selectedItemId.hasOwnProperty("social") &&
        this.selectedItemId.social
          ? this.selectedItemId.social
          : "";
      if (this.selectedItemId.hasOwnProperty("profile")) {
        this.showPreviousImg = true;
        this.profImage = this.selectedItemId.profile;
      }
    },
  },
  async mounted() {
    await this.getVolunteer();
    await this.$store.dispatch("respitecare/get_all_location_name");
    this.platformOptions = this.get_all_location_name;
    // .map((locationName) =>
    //   locationName.toLowerCase()
    // );
    await this.$store.dispatch("services/get_all");
    this.get_AllService.result.forEach((ele) => {
      this.services.push(ele.title);
      const today = new Date().toISOString().split("T")[0];
      this.maxDate = today;
    });
  },
};
</script>

<style></style>
